import React, {useEffect, useState} from 'react';
import {Box, Button, Typography, Link, Paper, Stack} from '@mui/material';
import {Link as RouterLink} from 'react-router';
import {Trans} from '@lingui/react/macro';
import useGdpr from "../../../hooks/useGdpr.ts";

const CookieConsent: React.FC = () => {

    const {consent, setConsent} = useGdpr()

    if (consent === 'accepted')
        return null;
    else if (consent === 'declined')
        return (
            <Paper elevation={6} sx={{position: 'fixed', bottom: 16, left: 16, right: 16, p: 2, zIndex: 2000}}>
                <Stack spacing={1} direction={{xs: 'column', sm: 'row'}} alignItems={{xs: 'flex-start', sm: 'center'}}
                       justifyContent="space-between">
                    <Typography variant="body2">
                        <Trans>You declined the Terms and Policy. You cannot use the app until you accept them. Reset to start over.</Trans>
                    </Typography>
                    <Box>
                        <Button size="small" variant="contained" onClick={() => setConsent('undefined')}
                                sx={{ml: 1}}><Trans>Reset</Trans></Button>
                    </Box>
                </Stack>
            </Paper>
        )
    else
        return (
            <Paper elevation={6} sx={{position: 'fixed', bottom: 16, left: 16, right: 16, p: 2, zIndex: 2000}}>
                <Stack spacing={1} direction={{xs: 'column', sm: 'row'}} alignItems={{xs: 'flex-start', sm: 'center'}}
                       justifyContent="space-between">
                    <Typography variant="body2">
                        <Trans>We use necessary cookies to make this app work. We will not use non-essential cookies
                            without your consent.</Trans>
                        <Trans>See our</Trans> <Link component={RouterLink} to="/privacy"><Trans>Privacy Policy</Trans></Link>.
                    </Typography>
                    <Box>
                        <Button size="small" onClick={() => setConsent('declined')}><Trans>Decline</Trans></Button>
                        <Button size="small" variant="contained" onClick={() => setConsent('accepted')}
                                sx={{ml: 1}}><Trans>Accept</Trans></Button>
                    </Box>
                </Stack>
            </Paper>
        )
};

export default CookieConsent;
